import React from 'react';
import { Dialog, Button, Box, Typography, CircularProgress } from '@mui/material';
import { ClientLockSVG, ClientUnlockSVG } from '../../../../components';
import { useTranslation } from 'react-i18next';
import { EmailSVG } from '../../../../components/svg/EmailSVG';
import { palette } from '../../../../styles/theme';
export default function ActionDialogNatura ({ showSendPinDialog, showBlockUserDialog, showRecoverPassDialog, onHide, data, toggleClientStatus, blockUser, recoverPass, actionModal, clientUIProps }) {
    const { t } = useTranslation();
    let show = false;
    let icon = false;
    let title;
    let body;
    let onClick;
    switch (actionModal) {
        case 'blockUser':
            icon = (<div><ClientLockSVG /></div>);
            show = showBlockUserDialog;
            title = t('details.dialog.block.title');
            body = (<h6 className='ActionDialogText'>{t('details.dialog.block.description')}<b>{data.formattedName}</b></h6>);
            onClick = blockUser;
            break;
        case 'sendPin':
            icon = (<div><ClientUnlockSVG /></div>);
            show = showSendPinDialog;
            title = t('details.dialog.pin.title');
            body = (<h6 className='ActionDialogText'>{data.status === 'recovery' && 're'}{t('details.dialog.pin.description.0')}<b>{data.telephone}.</b> <br /> {t('details.dialog.pin.description.1')}</h6>);
            onClick = toggleClientStatus;
            break;
        case 'recoverPass':
            icon = (<div><EmailSVG /></div>);
            show = showRecoverPassDialog;
            title = t('details.dialog.recoverPassword.title');
            body = (<h6 className='ActionDialogText'>{t('details.dialog.recoverPassword.description.0')}<b >{data.formattedName}</b> {t('details.dialog.recoverPassword.description.1')}</h6>);
            onClick = recoverPass;
            break;
        default:
            break;
    }

    return (
        <Dialog
            open={show}
            onClose={onHide}
            PaperProps={{ style: { padding: '32px', borderRadius: '16px', backgroundColor: palette.beige[50] } }}
        >
            <Box
                display='flex'
                justifyContent='center'
                flexDirection='column'
                gap={'24px'}
                width={'396px'}>
                <Box
                    gap='8px'
                    textAlign='center'>
                    <Box
                        display='flex'
                        flexDirection='column'
                        justifyContent='center'
                        marginBottom='8px'>
                        {icon}
                    </Box>
                    <Typography variant='h2' color={palette.primary.main} >{title}</Typography>
                </Box>
                {data && (<Box> {body}</Box>)}
                <Box
                    display='flex'
                    justifyContent='right'
                    gap='32px'>
                    <Button className='delete_button--cancel' onClick={onHide} disabled={clientUIProps.isLoading}>{t('buttons.cancel')}</Button>
                    <Button className='delete_button--submit' appearance='primary' onClick={onClick} disabled={clientUIProps.isLoading} >
                        {(clientUIProps.isLoading ? <CircularProgress size={24} style={{ color: 'white' }} /> : t('buttons.accept'))}
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
}
